import { principles, testimonials, trustStats } from "@/mocks/siteData";
import SectionHeader from "./SectionHeader";

export default function AboutSection() {
  return (
    <section id="about" className="relative scroll-mt-20 py-14 md:py-20 bg-primary-950 overflow-hidden">
      {/* decorative */}
      <div className="pointer-events-none absolute -right-24 top-10 w-80 h-80 rounded-full bg-primary-800/40"></div>
      <div className="pointer-events-none absolute -left-16 bottom-0 w-72 h-72 rounded-full bg-accent-500/10"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="关于我们"
          title="关于九色爆料"
          desc="我们希望做一座靠谱、克制又有温度的娱乐资讯驿站，让关心影视与文娱的你，在碎片时间里也能高效、安心地获取值得看的内容。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* principles */}
          <div className="space-y-4">
            {principles.map((p) => (
              <div key={p.title} className="flex items-start gap-4 rounded-xl bg-primary-900/60 border border-primary-800/60 p-4 md:p-5">
                <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-accent-500 text-primary-950 shrink-0">
                  <i className={`${p.icon} text-xl w-6 h-6 flex items-center justify-center`}></i>
                </span>
                <div>
                  <h3 className="font-heading font-bold text-background-50">{p.title}</h3>
                  <p className="mt-1 text-sm text-accent-100/80 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* stats + testimonials */}
          <div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
              {trustStats.map((s) => (
                <div key={s.label} className="rounded-xl bg-background-50/95 p-4 text-center">
                  <p className="font-heading font-black text-xl md:text-2xl text-primary-600">{s.value}</p>
                  <p className="mt-1 text-[11px] text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="rounded-2xl bg-accent-500 p-6 text-primary-950">
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider opacity-80">
                <i className="ri-double-quotes-l text-xl w-5 h-5 flex items-center justify-center"></i>
                读者口碑
              </div>
              <ul className="mt-4 space-y-3">
                {testimonials.map((t) => {
                  const nick = t.author.split("·").pop()?.trim() || "友";
                  return (
                    <li key={t.author} className="flex items-start gap-3">
                      <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary-950/15 font-heading font-bold text-sm shrink-0 mt-0.5">
                        {nick.slice(0, 1)}
                      </span>
                      <div>
                        <p className="text-sm leading-relaxed">“{t.quote}”</p>
                        <p className="mt-1 text-xs font-semibold opacity-80">{t.author} · {t.tag}</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}